import React, { FC } from 'react';
import { NavbarLogoWrapper } from './NavbarLogo.styled';
import logo from '../../assets/kujipylogo.webp';
import { Link } from 'react-router-dom';

const NavbarLogo: FC = () => (
  <NavbarLogoWrapper as={Link} to="/" aria-label="Kujipy, ir al inicio">
    <img src={logo} alt="Kujipy logo" />
  </NavbarLogoWrapper>
);

export default NavbarLogo;
